import { useQuery, useSuspenseQuery } from "@tanstack/react-query";

import keys from "./keys";
import { Client } from "./types";
import { useApi } from "../client";

export const useClients = () => {
  const api = useApi();

  return useQuery({
    queryKey: keys.all(),
    queryFn: async (): Promise<Client[]> => {
      const clients = await api.get("clients");
      return await clients.json();
    },
  });
};

export const useClient = ({ id }: { id: string }) => {
  const api = useApi();

  return useQuery({
    queryKey: keys.one(id),
    queryFn: async (): Promise<Client> => {
      const client = await api.get(`clients/${id}`);
      return await client.json();
    },
  });
};

export const useClientSuspense = ({ id }: { id: string }) => {
  const api = useApi();

  return useSuspenseQuery({
    queryKey: keys.one(id),
    queryFn: async (): Promise<Client> => {
      const client = await api.get(`clients/${id}`);
      return await client.json();
    },
  });
};
